var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconFunnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64696 2.33995L0.94289 10.0516C0.90413 10.0905 0.876144 10.1396 0.862817 10.1924L0.00889449 13.623C-0.0166488 13.7262 0.01367 13.836 0.0889671 13.9114C0.14594 13.9684 0.223569 14 0.302975 14C0.327297 14 0.352174 13.997 0.376384 13.9909L3.80385 13.1361C3.85727 13.1227 3.9058 13.0948 3.94456 13.056L11.6493 5.345L8.64696 2.33995Z",
    fill: "#1D4469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.556 1.28842L12.6984 0.430057C12.1252 -0.14363 11.1263 -0.143074 10.5538 0.430057L9.50327 1.4815L12.5055 4.48644L13.556 3.435C13.8423 3.14854 14 2.76727 14 2.36176C14 1.95626 13.8423 1.57499 13.556 1.28842Z",
    fill: "#1D4469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconFunnel);
export default __webpack_public_path__ + "static/media/EditIconFunnel.7969f5b9bc73d68594424be77c541a57.svg";
export { ForwardRef as ReactComponent };